import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import Header from '../Header';
import Footer from '../Footer';
import SubnavBar from '../SubnavBar';
import CookiesDisclaimer from '../CookiesDisclaimer';
import SideMenu from '../ManageListing/SideMenu/SideMenu';
import OwnerSideMenu, { OwnerMenuContent } from '../OwnerReporting/OwnerSideMenu/OwnerSideMenu';
import {
  Grid,
  Row,
  Col
} from 'react-bootstrap';

import cs from '../../components/commonStyle.css';
import s from './Layout.css';
class UserLayout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    // Owner space (block 6): pathname of the page, shows the owner side menu instead of showSideMenu ; ownerMenuWrapContent puts the
    // page in the column next to the menu (for pages that are not already a column).
    ownerMenuPath: PropTypes.string,
    ownerMenuWrapContent: PropTypes.bool,
  };

  render() {
    // dashboard, revenue and inbox are columns of their own: give them the width of the screen instead of the 1080px account pages
    const wideOwnerPage = Boolean(this.props.ownerMenuPath && this.props.ownerMenuWrapContent);
    return (
      <>
        <Header />
        <div className={s.userLayoutBg}>
          <SubnavBar />
          <Grid fluid className={'listingContainer'} style={wideOwnerPage ? { maxWidth: 'var(--max-content-width)' } : undefined}>
            <Row>
              {this.props.ownerMenuPath ?
                <Col xs={12} sm={12} md={wideOwnerPage ? 3 : 4} lg={wideOwnerPage ? 2 : 4} className={cs.spaceTop6}>
                  <OwnerSideMenu activePath={this.props.ownerMenuPath} />
                </Col>
                : this.props.showSideMenu &&
                <Col xs={12} sm={12} md={4} lg={4} className={cs.spaceTop6}>
                  <SideMenu showSideMenu={this.props.showSideMenu} />
                </Col>
              }
              {this.props.ownerMenuPath && this.props.ownerMenuWrapContent
                ? <OwnerMenuContent>{this.props.children}</OwnerMenuContent>
                : this.props.children}
            </Row>
          </Grid>
          <Footer whiteBg={true} />
        </div>
        <CookiesDisclaimer />
      </>
    );
  }
}

export default withStyles(cs, s)(UserLayout);